<template>
  <v-card flat>
    <v-row
      no-gutters
      class="px-4"
    >
      <v-col
        v-if="Object.keys(filteredOfficeList).includes('organization')"
        cols="12"
        class="px-3"
        :sm="6"
        col="12"
        :md="3"
      >
        <WBDOrganizationSelectorFilter
          :remote-list="remoteList"
          :selected-option-value="filteredOfficeList"
          @onOrganizationListSelectorFilterChange="onOrganizationListSelectorFilterChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        col="12"
        :md="3"
      >
        <WBDStatusSelectorFilter
          @onOfficeStatusSelectorFilterChange="onOfficeStatusSelectorFilterChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        col="12"
        :md="3"
      >
        <WBDOfficeTypeSelectorFilter
          @onOfficeTypeSelectorFilterChange="onOfficeTypeSelectorFilterChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        col="12"
        :md="3"
      >
        <WBDRegionListSelectorFilter
          :filtered-laborer-list="''"
          :remote-list="[]"
          @onRegionListSelectorFilterChange="onRegionListSelectorFilterChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        col="12"
        :md="3"
      >
        <WBDCitySelectorFilter
          :filtered-laborer-list="''"
          :remote-list="[]"
          @onCitySelectorFilterChange="onCitySelectorFilterChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        col="12"
        :md="3"
      >
        <WBDShiftProviderLevelList
          :remote-list="[]"
          @onShiftProviderLevelChange="onShiftProviderLevelChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        col="12"
        :md="6"
      >
        <WBSearchQueryFilter
          :remote-value="''"
          :label="'Поиск по адресу, названию или код завода'"
          @onSearchQueryFilterChange="onSearchQueryFilterChange"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import WBDOrganizationSelectorFilter from '@/components/common/filter/organization-selector-filter'
import WBDStatusSelectorFilter from '@/components/common/filter/office-status-filter'
import WBDOfficeTypeSelectorFilter from '@/components/common/filter/office-type-filter'
import WBDRegionListSelectorFilter from '@/components/common/filter/region-selector-filter'
import WBSearchQueryFilter from '@/components/common/filter/search-query-filter'
import WBDCitySelectorFilter from '@/components/common/filter/city-search-filter'
import WBDShiftProviderLevelList from '@/components/common/filter/shift-provider-level-type-filter'

export default {
  name: 'WBDOfficeListFilter',
  components: {
    WBDShiftProviderLevelList,
    WBDOrganizationSelectorFilter,
    WBDStatusSelectorFilter,
    WBDOfficeTypeSelectorFilter,
    WBSearchQueryFilter,
    WBDCitySelectorFilter,
    WBDRegionListSelectorFilter
  },
  props: {
    officeListFilterSet: {
      type: Object
    }
  },
  data: () => ({
    searchQuery: '',
    filteredOfficeList: '',
    remoteList: [],
    loading: true,
  }),
  computed: {

  },
  watch: {
    officeListFilterSet: {
      handler (val) {
        for (const [key, value] of Object.entries(val)) {
          if (this.officeListFilterSet[key] !== value) {
            this.officeListFilterSet[key] = value
          }
        }
      },
      deep: true,
    },
  },
  created () {
  },
  methods: {
    onRegionListSelectorFilterChange (data) {
      this.officeListFilterSet.region = data
    },
    onOrganizationListSelectorFilterChange (data) {
      this.officeListFilterSet.organization = data
    },
    onOfficeStatusSelectorFilterChange (data) {
      this.officeListFilterSet.status = data
    },
    onOfficeTypeSelectorFilterChange (data) {
      this.officeListFilterSet.type = data
    },
    onSearchQueryFilterChange (data) {
      this.officeListFilterSet.searchQuery = data
    },
    onCitySelectorFilterChange (data) {
      this.officeListFilterSet.city = data
    },
    onShiftProviderLevelChange (data) {
      this.officeListFilterSet.shiftProviderLevel = data
    },
  }
}
</script>
<style lang="scss" scoped>
  .office-item {
    cursor: pointer;
  }
</style>
